<div class="flex items-center">
  <div class="flex-1" [ngClass]="{ 'pr-lg': action }">
    <div class="text-lg leading-lg font-semibold">
      @if (title) {
        {{ title }}
      } @else {
        <ng-content select="[slot=title]"></ng-content>
      }
    </div>

    <div class="mt-2xs text-base leading-base">
      @if (subTitle) {
        {{ subTitle }}
      } @else {
        <ng-content select="[slot=subTitle]"></ng-content>
      }
    </div>
  </div>

  @if (action) {
    <a [routerLink]="action.link" (click)="actionClicked.emit()">
      <mg-button
        variant="ghost"
        class="flex"
        size="small-shrink"
        [icon]="action.icon"
        iconPosition="right"
      >
        <span
          class="lowercase first-letter:uppercase"
          [ngClass]="{ 'hidden md:inline-block': !action.showTitleOnMobile }"
        >
          {{ action.title }}
        </span>
      </mg-button>
    </a>
  }
</div>
